module.exports = __webpack_public_path__ + "media/images/hero-4-52531e01.jpg";